import React from "react";

import { Text } from "@whoosh/design-system/src/components/primitive";
import { useGetClubCurrency } from "@whoosh/features/src/ClubCurrency";
import { ConvertCentsToDollars } from "@whoosh/utilities/src/Currency";

export const PriceDisplay = ({
  priceRange,
}: {
  priceRange: {
    minPrice: number;
    maxPrice: number;
  };
}) => {
  const shouldDisplayRange =
    priceRange.minPrice !== 0 &&
    priceRange.maxPrice !== 0 &&
    priceRange.minPrice !== priceRange.maxPrice;

  const { currencySymbol } = useGetClubCurrency();

  const displayMinPrice = ConvertCentsToDollars(priceRange.minPrice);
  const displayMaxPrice = ConvertCentsToDollars(priceRange.maxPrice);

  const priceDisplay = shouldDisplayRange
    ? `${currencySymbol}${displayMinPrice} - ${currencySymbol}${displayMaxPrice}`
    : `${currencySymbol}${displayMinPrice}`;

  return (
    <Text
      variant="mainBaseMedium"
      color="text-secondary"
      testID="lesson-price-display"
    >
      {priceDisplay}
    </Text>
  );
};
